import { IconBed } from '@/app/common/icons/libraryIcons';
import React from 'react';
import Stars from '@/app/common/components/Stars';
import { isNil } from '../../../../../Utilities';
import {
  AutocompleteSuggestionCheck,
  AutocompleteSuggestionIcon,
  AutocompleteSuggestionLabel,
  SuggestionContent,
} from './styled';
import { convertImageUrlByWidthHeight } from '../../../../../utils/images';

type CreateSuggestion = {
  id: string;
  value: string;
  iconImage: string;
  stars: number;
};

const ICON_SIZE_2X = 64;
export const createSuggestion = ({ id, value, iconImage, stars }: CreateSuggestion) => {
  const icon = iconImage === '' ? <IconBed size="16" /> : null;
  // Painted 32x32 as a background-image, so there is no srcset to pick a candidate: ask for the 2x
  // one outright, or it is soft on every retina screen.
  const optimisedIconImage = convertImageUrlByWidthHeight(iconImage, ICON_SIZE_2X, ICON_SIZE_2X);
  const showStars = !isNil(stars) && stars > 0;
  const starsContent = showStars ? <Stars stars={stars} maxRating={5} hideEmpty={false} /> : null;

  return {
    id,
    value,
    suggestionContent: (
      <SuggestionContent>
        <AutocompleteSuggestionIcon className="oss-ui-autocomplete-suggestion-icon" iconImage={optimisedIconImage}>
          {icon}
        </AutocompleteSuggestionIcon>
        <AutocompleteSuggestionLabel>{value}</AutocompleteSuggestionLabel>
        {showStars && (
          <AutocompleteSuggestionCheck className="oss-ui-autocomplete-suggestion-check">
            {starsContent}
          </AutocompleteSuggestionCheck>
        )}
      </SuggestionContent>
    ),
  };
};
